import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { EngagementProvider } from "@/contexts/EngagementContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import ReconEngine from "@/pages/ReconEngine";
import PenTestSuite from "@/pages/PenTestSuite";
import AssetDiscovery from "@/pages/AssetDiscovery";
import AIChat from "@/pages/AIChat";
import CyberTwin from "@/pages/CyberTwin";
import Compliance from "@/pages/Compliance";
import ThreatIntel from "@/pages/ThreatIntel";
import Incidents from "@/pages/Incidents";
import Reports from "@/pages/Reports";
import RiskScoring from "@/pages/RiskScoring";
import AutonomousRedTeam from "@/pages/AutonomousRedTeam";
import AIBlueTeam from "@/pages/AIBlueTeam";
import ExploitLab from "@/pages/ExploitLab";
import Engagements from "@/pages/Engagements";
import ImportFindings from "@/pages/ImportFindings";
import ScanWorkers from "@/pages/ScanWorkers";
import NucleiTemplates from "@/pages/NucleiTemplates";
import AttackSurface3D from "@/pages/AttackSurface3D";
import Configuration from "@/pages/Configuration";
import ModulePlaceholder from "@/pages/ModulePlaceholder";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return (
    <EngagementProvider>
      <Layout>{children}</Layout>
    </EngagementProvider>
  );
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster
          position="top-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "#0f172a",
              border: "1px solid #1e293b",
              color: "#f8fafc",
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: "12px",
              borderRadius: "2px",
            },
          }}
        />
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/engagements" element={<Protected><Engagements /></Protected>} />
            <Route path="/import" element={<Protected><ImportFindings /></Protected>} />
            <Route path="/scans" element={<Protected><ScanWorkers /></Protected>} />
            <Route path="/nuclei-templates" element={<Protected><NucleiTemplates /></Protected>} />
            <Route path="/attack-surface" element={<Protected><AttackSurface3D /></Protected>} />
            <Route path="/recon" element={<Protected><ReconEngine /></Protected>} />
            <Route path="/pentest" element={<Protected><PenTestSuite /></Protected>} />
            <Route path="/red-team" element={<Protected><AutonomousRedTeam /></Protected>} />
            <Route path="/exploit-lab" element={<Protected><ExploitLab /></Protected>} />
            <Route path="/blue-team" element={<Protected><AIBlueTeam /></Protected>} />
            <Route path="/soc-copilot" element={<Protected><AIChat persona="soc" /></Protected>} />
            <Route path="/threat-intel" element={<Protected><ThreatIntel /></Protected>} />
            <Route path="/incidents" element={<Protected><Incidents /></Protected>} />
            <Route path="/compliance" element={<Protected><Compliance /></Protected>} />
            <Route path="/ciso-advisor" element={<Protected><AIChat persona="ciso" /></Protected>} />
            <Route path="/risk" element={<Protected><RiskScoring /></Protected>} />
            <Route path="/assets" element={<Protected><AssetDiscovery /></Protected>} />
            <Route path="/cyber-twin" element={<Protected><CyberTwin /></Protected>} />
            <Route path="/reports" element={<Protected><Reports /></Protected>} />
            <Route path="/configuration" element={<Protected><Configuration /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
